module.exports = __webpack_public_path__ + "static/media/content-06.231a5ac8.png";